function patch_closeClick(e) {
	e.preventDefault();
	card = this.closest('.Card');
	if (card) {
		card.classList.remove('Card--show');
	}
	document.body.classList.remove('is-cardShown');
}

document.addEventListener('DOMContentLoaded', function() {

	var close = document.getElementsByClassName('Close'),
		card = null;
	if (close) {
		for (var i = 0, l = close.length; i < l; i++) {
			close[i].addEventListener('click', patch_closeClick);
		}
	}

});
